import { Component, OnInit, EventEmitter, Input, Output } from "@angular/core";
import { ReportsService } from "../../../core/reports.service";
import { of } from "rxjs";
import { tap, catchError } from "rxjs/operators";
import { TranslateService } from "@ngx-translate/core";
import { PermissionsService } from "../../../../core/permissions.service";
import { ReportOptionsService } from "../report-options.service";

@Component({
  selector: "app-vehicle-group-selector",
  templateUrl: "./vehicle-group-selector.component.html",
  styleUrls: ["./vehicle-group-selector.component.scss"],
})
export class VehicleGroupSelectorComponent implements OnInit {
  vehiclesGroupsOptions = [];
  selectedVehicleGroup: any = {
    label: this.translateService.instant("reports.all-groups"),
    value: 0,
  };
  vehicleGroupsIsLoading = true;

  @Input() reportId: number;
  @Input() archivePermission: Date;
  @Input() label = this.translateService.instant("reports.group");
  @Input() selectedGroupId: number;
  @Input() dropdownClass: string = "dropdown--gray";
  @Input() dropdownIconClass: string = "fa fa-chevron-down";
  @Output() selectedGroupIdChange = new EventEmitter<number>();
  @Output() archivePermissionChange = new EventEmitter<Date>();

  constructor(
    private reportsService: ReportsService,
    private translateService: TranslateService,
    public permissionsService: PermissionsService,
    private reportOptionsService: ReportOptionsService
  ) {}

  ngOnInit() {
    this.selectedGroupIdChange.emit(this.selectedGroupId || 0);
    this.reportsService.filterByVehicleGroupId.next(this.selectedGroupId || 0);
    this.loadSelectOptions();
  }

  loadSelectOptions() {
    this.reportsService
      .getVehiclesGroups()
      .pipe(
        tap((data: any[]) => {
          if (data.length > 0) {
            this.vehiclesGroupsOptions.push({
              label: this.translateService.instant("reports.all-groups"),
              value: 0,
              vehicles: [],
            });
            data.forEach((group) => {
              this.vehiclesGroupsOptions.push({
                label: group.name,
                value: group.id,
                vehicles: group.vehiclesIds,
              });
            });
          }
          if (this.selectedGroupId) {
            this.selectedVehicleGroup = this.vehiclesGroupsOptions.find(
              (vehiclesGroup) => vehiclesGroup.value === this.selectedGroupId
            );
          }
          this.vehicleGroupsIsLoading = false;
        }),
        catchError((error, caught) => {
          console.log("Problem z pobieraniem grup pojazdow " + error);
          this.vehiclesGroupsOptions = [];
          this.selectedGroupIdChange.emit(-1);
          this.reportsService.showServerError();
          return of();
        })
      )
      .subscribe();
  }

  onSelectedGroupIdChange() {
    if (this.selectedVehicleGroup) {
      this.selectedGroupIdChange.emit(this.selectedVehicleGroup.value);
      this.reportOptionsService.groupName = this.selectedVehicleGroup.label;
      // this.permissionsService
      //   .getArchivePermissions(
      //     this.reportId,
      //     -1,
      //     this.selectedVehicleGroup.value
      //   )
      //   .subscribe((res) => {
      //     this.permissionsService.setArchivePermission.next(res);
      //   });
      if (this.selectedVehicleGroup.value === 0) {
        this.reportsService.filterByVehicleGroupId.next(0);
      } else {
        this.reportsService.filterByVehicleGroupId.next(
          this.selectedVehicleGroup.vehicles
        );
      }
    } else {
      this.selectedGroupIdChange.emit(0);
      this.reportsService.filterByVehicleGroupId.next(0);
      // this.permissionsService
      //   .getArchivePermissions(this.reportId, -1, 0)
      //   .subscribe((res) => {
      //     this.permissionsService.setArchivePermission.next(res);
      //   });
    }
  }
}
